"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DROPDOWN_OPTIONS = exports.USER_CANCELLATION_REASONS = exports.QUESTION_STATS = exports.APP_USAGE_GRAPH = exports.EARNINGS_GRAPH = exports.USER_FEEDBACK_GRAPH = exports.USER_FEEDBACKS = exports.USER_BREAKDOWN = exports.USER_STATUS = exports.ESubType = exports.EARNINGS = exports.IMPORT_STATS = void 0;
const client_1 = require("@apollo/client");
exports.IMPORT_STATS = (0, client_1.gql) `
  query ImportStats($from: Date, $to: Date, $force: Boolean) {
    admin {
      importStats(force: $force, from: $from, to: $to) {
        totalBatches
        mockTestBatches
        questionCount
        stationCount
        chapterCount
      }
    }
  }
`;
exports.EARNINGS = (0, client_1.gql) `
  query Earnings(
    $subType: Int
    $duration: Int
    $from: Date
    $to: Date
    $force: Boolean!
    $source: Int
    $universityId: Int
    $useNetEarning: Boolean
    $productIds: [Int]
    $countryName: String
    $graduationYear: Int
    $classYear: String
  ) {
    admin {
      earnings(
        subType: $subType
        duration: $duration
        universityId: $universityId
        from: $from
        to: $to
        force: $force
        source: $source
        useNetEarning: $useNetEarning
        productIds: $productIds
        countryName: $countryName
        graduationYear: $graduationYear
        classYear: $classYear
      ) {
        entitlement {
          id
          name
        }
        duration
        name
        subscriptionCount
        totalEarning
        invoiceCount
        breakdown {
          entitlement {
            id
            name
          }
          duration
          name
          subscriptionCount
          totalEarning
          invoiceCount
        }
      }
    }
  }
`;
var ESubType;
(function (ESubType) {
    ESubType[ESubType["ALL"] = 0] = "ALL";
    ESubType[ESubType["NEW"] = 1] = "NEW";
    ESubType[ESubType["OLD"] = 2] = "OLD";
})(ESubType = exports.ESubType || (exports.ESubType = {}));
exports.USER_STATUS = (0, client_1.gql) `
  query UserStatus($from: Date, $to: Date, $force: Boolean!) {
    admin {
      userStatus(from: $from, to: $to, force: $force) {
        subscribed
        unRegistered
        registered
        total
      }
    }
  }
`;
exports.USER_BREAKDOWN = (0, client_1.gql) `
  query UserBreakdown(
    $from: Date
    $to: Date
    $subscribed: Boolean
    $force: Boolean!
  ) {
    admin {
      userBreakdown(
        from: $from
        to: $to
        subscribed: $subscribed
        force: $force
      ) {
        devices {
          key
          value
        }
        graduations {
          key
          value
        }
        countries {
          key
          value
        }
        classYears {
          key
          value
        }
        universities {
          key
          value
        }
      }
    }
  }
`;
exports.USER_FEEDBACKS = (0, client_1.gql) `
  query UserFeedbacks(
    $rating: Int
    $productId: Int
    $from: Date
    $to: Date
    $force: Boolean!
    $description: Boolean
  ) {
    admin {
      userFeedbacks(
        from: $from
        to: $to
        force: $force
        productId: $productId
        rating: $rating
        description: $description
      ) {
        total
        average
        ratings {
          value
          count
        }
        feedbacks {
          user {
            id
            displayName
            username
            firstName
            lastName
            createdAt
          }
          spends
          average
          reviews {
            id
            userId
            createdAt
            rating
            feedback
            product {
              id
              name
            }
          }
        }
      }
    }
  }
`;
exports.USER_FEEDBACK_GRAPH = (0, client_1.gql) `
  query UserFeedbackGraph($productId: Int, $year: Int) {
    admin {
      userFeedbacksGraph(productId: $productId, year: $year) {
        month
        count
        value
        stats {
          count
          value
          product {
            id
            name
          }
        }
      }
    }
  }
`;
exports.EARNINGS_GRAPH = (0, client_1.gql) `
  query EarningsGraph(
    $year: Int
    $subType: Int
    $source: Int
    $universityId: Int
    $force: Boolean
    $useNetEarning: Boolean
    $productIds: [Int]
  ) {
    admin {
      earningsGraph(
        year: $year
        subType: $subType
        source: $source
        universityId: $universityId
        force: $force
        useNetEarning: $useNetEarning
        productIds: $productIds
      ) {
        month
        count
        value
        stats {
          count
          value
          product {
            id
            name
          }
        }
      }
    }
  }
`;
exports.APP_USAGE_GRAPH = (0, client_1.gql) `
  query AppUsageGraph(
    $year: Int
    $force: Boolean
    $productIds: [Int]
    $groupBy: String
  ) {
    admin {
      appUsageGraph(
        year: $year
        force: $force
        productIds: $productIds
        groupBy: $groupBy
      ) {
        month
        count
        value
        stats {
          count
          value
          product {
            id
            name
          }
        }
      }
    }
  }
`;
exports.QUESTION_STATS = (0, client_1.gql) `
  query QuestionStats(
    $productId: Int
    $from: Date
    $to: Date
    $force: Boolean!
  ) {
    admin {
      questionStats(
        force: $force
        from: $from
        to: $to
        productId: $productId
      ) {
        totalQuestions
        totalMockQuestions
        mockTests {
          id
          name
          count
          voteScore
          firstAttemptScore
          score
          lastEditScore
        }
        mockCategories {
          id
          name
          count
          voteScore
          firstAttemptScore
          score
          lastEditScore
        }
        entitlements {
          id
          name
          count
          voteScore
          firstAttemptScore
          score
          lastEditScore
        }
        difficulties {
          id
          name
          count
          voteScore
          firstAttemptScore
          score
          lastEditScore
        }
      }
    }
  }
`;
exports.USER_CANCELLATION_REASONS = (0, client_1.gql) `
  query UserCancellationReasons(
    $productId: Int
    $from: Date
    $to: Date
    $source: Int
    $force: Boolean!
  ) {
    admin {
      userCancellationReasons(
        force: $force
        from: $from
        to: $to
        productId: $productId
        source: $source
      ) {
        total
        feedbacks {
          id
          username
          displayName
          firstName
          lastName
          createdAt
          subscriptions(active: true) {
            id
            comment
            feedback
            periodEndAt
            updatedAt
            purchaseSource
            product {
              id
              name
              duration
            }
          }
        }
      }
    }
  }
`;
exports.DROPDOWN_OPTIONS = (0, client_1.gql) `
  query DropdownOptions($table: String, $search: String, $force: Boolean!) {
    admin {
      dropdownOptions(force: $force, search: $search, table: $table) {
        key
        value
        metaData {
          key
          value
        }
      }
    }
  }
`;
